import { useState } from 'react'
import { HiOutlineLocationMarker, HiOutlineShare } from 'react-icons/hi'
import SEO from '../components/SEO'
import { BsTelephone } from 'react-icons/bs'
import { MdOutlineEmail } from 'react-icons/md'
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa'

const contactInfo = [
  {
    icon: HiOutlineLocationMarker,
    title: 'Address — Pakistan',
    content: '89 C, Punjab Housing Society Lahore',
  },
  {
    icon: HiOutlineLocationMarker,
    title: 'Address — USA',
    content: '1209 Mountain Road Pl NE Ste R, Albuquerque, NM 87110',
  },
  {
    icon: BsTelephone,
    title: 'Phone — Pakistan',
    content: '+92-309-8391932',
    href: 'tel:+923098391932',
  },
  {
    icon: BsTelephone,
    title: 'Phone — USA',
    content: '+1 (575) 303-9239',
    href: 'tel:+15753039239',
  },
  {
    icon: MdOutlineEmail,
    title: 'Email',
    content: 'business@mindvista.io',
    href: 'mailto:business@mindvista.io',
  },
]

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setFormData({ name: '', email: '', phone: '', message: '' })
  }

  return (
    <div>
      <SEO title="Contact Us" description="Get in touch with MindVista to discuss your next project." />
      <section className="relative min-h-[62vh] overflow-hidden">
        <video autoPlay muted loop playsInline className="absolute inset-0 h-full w-full object-cover">
          <source src="/images/home/acheivements.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/75" />

        <div className="container-main relative z-10 flex min-h-[62vh] flex-col items-start justify-center">
          <span className="section-kicker">Contact Us</span>
          <h1 className="mt-4 max-w-4xl text-5xl font-bold md:text-7xl">Let&apos;s talk</h1>
          <p className="mt-4 max-w-2xl text-lg text-[#b4b4b4]">Tell us about your need and we will help.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="container-main grid gap-8 lg:grid-cols-[1fr_1.2fr]">
          <div className="space-y-4">
            {contactInfo.map((item) => {
              const Icon = item.icon
              return (
                <article key={item.title} className="neo-card neo-card-hover p-6">
                  <div className="flex items-start gap-4">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/15 bg-[#151515] text-[rgb(249,193,37)]">
                      <Icon className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-semibold text-white">{item.title}</h3>
                      {item.href ? (
                        <a href={item.href} className="mt-1 block text-[#aaaaaa] hover:text-[rgb(249,193,37)]">
                          {item.content}
                        </a>
                      ) : (
                        <p className="mt-1 text-[#aaaaaa]">{item.content}</p>
                      )}
                    </div>
                  </div>
                </article>
              )
            })}

            <article className="neo-card p-6">
              <div className="flex items-start gap-4">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/15 bg-[#151515] text-[rgb(249,193,37)]">
                  <HiOutlineShare className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-white">Social</h3>
                  <p className="mt-1 text-[#aaaaaa]">Follow us on social media</p>
                  <div className="mt-3 flex gap-2">
                    <a href="https://facebook.com" target="_blank" rel="noreferrer" className="btn-outline p-2.5" aria-label="facebook"><FaFacebookF className="h-4 w-4" /></a>
                    <a href="https://twitter.com" target="_blank" rel="noreferrer" className="btn-outline p-2.5" aria-label="twitter"><FaTwitter className="h-4 w-4" /></a>
                    <a href="https://instagram.com" target="_blank" rel="noreferrer" className="btn-outline p-2.5" aria-label="instagram"><FaInstagram className="h-4 w-4" /></a>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div className="glass-card rounded-3xl p-8 md:p-10">
            <h2 className="text-4xl font-semibold md:text-5xl">Fill Up The Form</h2>

            <form onSubmit={handleSubmit} className="mt-7 space-y-4">
              <div>
                <label htmlFor="name" className="mb-2 block text-sm font-medium text-white">Your Name *</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} className="input-dark" placeholder="Enter your name" required />
              </div>

              <div>
                <label htmlFor="email" className="mb-2 block text-sm font-medium text-white">Email Address *</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} className="input-dark" placeholder="Enter your email" required />
              </div>

              <div>
                <label htmlFor="phone" className="mb-2 block text-sm font-medium text-white">Phone Number</label>
                <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} className="input-dark" placeholder="Enter your phone number" />
              </div>

              <div>
                <label htmlFor="message" className="mb-2 block text-sm font-medium text-white">Message *</label>
                <textarea id="message" name="message" rows={6} value={formData.message} onChange={handleInputChange} className="input-dark" placeholder="Enter your message here" required />
              </div>

              <button type="submit" className="btn-primary w-full">Submit</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact
